import React, { useState, useEffect } from 'react';
import NavBar from '../../components/navbar';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import PaintCapacityWidget from './paintCapacityWidget';
import paintOrderService from '../../utils/paint-orders';

const PaintCapacityDashboardPage = (props) => {
  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Capacidad Taller', link: '/paint-capacity' },
    { name: 'Dashboard', link: '/paint-capacity-dashboard' }
  ];

  const [errors, setErrors] = useState({});
  const [input, setInput] = useState({
    date: '',
  });

  const [paintOrders, setPaintOrders] = useState([]);
  const [showData, setShowData] = useState(false);

  const TYPES = [
    {_id: 1,  name: 'HOGAR Y OBRA', capacity: 600, decrementPerHour: 75 },
    {_id: 2, name: 'REVESTIMIENTO', capacity: 450, decrementPerHour: 56.25 },
    {_id: 3, name: 'INDUSTRIA', capacity: 250, decrementPerHour: 31.25 }
  ];

  useEffect(() => {
    // reload every 5 minutes
    const intervalId = setInterval(() => {
      window.location.reload();
    }, 3 * 60 * 1000);

    // cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  /**
   * Validates if all the fields are included
   */
  const validateForm = () => {
      const errors = {};
      if (!input.date) {
          errors.date = 'La fecha es requerida';
      }
      return errors;
  };


  const handleKeyUp = (e) => {
    const allErrors = validateForm(input);
    // so that not all errors are displayed at the same time the specific error is destructured
    const err = allErrors[e.target.name];
    if (err) {
        setErrors({ ...errors, [e.target.name]: err });
    } else {
        // but if that field has no error it is removed from the errors and the others are displayed
        const rest = { ...errors };
        delete rest[e.target.name];
        setErrors(rest);
    }
  };

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const lookupPaintOrders = () => {
    // Search the paint orders by date
    paintOrderService.getPaintOrdersByDate({ date: input.date })
      .then((response) => {
        if (response.success) {
          setPaintOrders(response.data);
          setShowData(true);
        } else {
          setErrors({ ...errors, general: 'No se encontraron ordenes para la fecha seleccionada' });
        }
      })
      .catch((error) => {
        setErrors({ ...errors, general: error.message });
      });
  };

  /**
   * Generate the list of ordered keys needed for the table
   * @param {*} object
   * @returns
   */
  const getObjectKeysForTable = (object) => {
    const filteredKeys = ['date', 'paintType', 'liters', 'status', 'orderNumber', 'observations'];
    return filteredKeys;
  }

  /**
   * Generates the table with the receipts on it
   * @param {*} receipts
   * @returns
   */
  const generateTableOrders = (orders) => {
    const headers = orders.length ? getObjectKeysForTable(orders[0]) : [];

    const generateHeaders = (headers) => {
      const HEADER_MAPS = {
        date: 'Fecha',
        paintType: 'Tipo de Pintura',
        liters: 'Litros',
        orderNumber: 'Num. Orden',
        observations: 'Observaciones',
        status: 'Estado',
      };

      const tableHeaders = [];
      if (headers) {
        for (let i = 0; i < headers.length; i++) {
          tableHeaders.push(
            <th className="text-center" key={`col-he-${i}`} scope="col">
              {HEADER_MAPS[headers[i]]}
            </th>
          );
        }
      }
      return tableHeaders;
    };

    // Delete the order
    const deleteItem = (order) => {
      console.log(order)
      const confirm = window.confirm('¿Esta seguro que desea eliminar la orden?');
      if (confirm) {
        paintOrderService.deletePainOrdersById(order._id)
          .then((response) => {
            if (response.success) {
              setPaintOrders(paintOrders.filter(o => o._id !== order._id));
              alert('Orden eliminada correctamente');
            } else {
              alert('Error al eliminar la orden: ' + response.message);
            }
          })
          .catch((error) => {
            alert('Error al eliminar la orden: ' + error.message);
          });
      }
    };

    const generateRowData = (order) => {
      const data = [];
      const keys = getObjectKeysForTable(order);

      keys.forEach((key, index) => {
        let value = order[key];
        if (key === 'date') {
          value = value.split('T')[0];
        }
        data.push(<td key={`${index}-${value}`}>{value}</td>);
      });

      // Add the delete action button
      data.push(
        <td className="row-clickeable text-center"
            onClick={() => deleteItem(order)}
            key={`${order._id}-actions`}>
            <i className="material-icons icon-action icon-md-18">delete</i>
        </td>
      );

      return data;
    };

    const generateRows = (orders) => {
      const productItems = [];
      if (orders) {
        for (let i = 0; i < orders.length; i++) {
          productItems.push(
            <tr
              className="row-clickeable"
              key={`row-${i}`}
            >
              {generateRowData(orders[i])}
            </tr>
          );
        }
      }
      return productItems;
    };

    return (
      <>
        <table
          className="table table-sm table-responsive table-hover table-bordered table-custom"
          style={{ maxWidth: '1140px' }}
        >
          <thead className="thead-light">
            <tr>{generateHeaders(headers)}</tr>
          </thead>
          <tbody>{generateRows(orders)}</tbody>
        </table>
      </>
    );
  };

  return (
    <div id="main-account" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="account" items={breadcrumbItems} />
      <div className="menu-container-lab">
         <div className="form-group receipt-data w-100">
          <div className="date-picker">
            <label>Fecha</label>
            <input
              type="date"
              name="date"
              className="form-control"
              placeholder="Fecha"
              value={input.date}
              onChange={handleChange}
              onKeyUp={handleKeyUp}
            />
            <p className="error-login">{errors.date}</p>
          </div>
          <div className="btn-add">
            <button
              type="button"
              className="btn btn-dark btn-block"
              onClick={lookupPaintOrders}
            >
              Buscar
            </button>
          </div>
        </div>
         <div className="row mt-4 mx-auto">
          <PaintCapacityWidget
            selectedDate={input.date}
            paintOrders={paintOrders}
            types={TYPES}
            showData={showData}
          />
         </div>
         { paintOrders.length > 0 &&
            (<div className="row mt-4 mx-auto w-100">
              <h4>Detalles de pedidos planificados para el dia: { input.date }</h4>
              { generateTableOrders(paintOrders) }
            </div>)
         }
         { paintOrders.length === 0 && showData && (
            <h4 className="row mt-4 mx-auto w-100">
              No hay ordenes planificadas para el dia: { input.date }
            </h4>
         )}
      </div>
    </div>
  );
};

export default PaintCapacityDashboardPage;
